import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Select from "react-select";
import * as codeActions from "../../actions/codeActions";

const ProjectCategorySelect = ({
  value: initialValue,
  isMulti = false,
  onChange,
  codes = [],
  actions,
  label,
  placeholder,
  disabled
}) => {
  if (!codes.length) {
    actions.loadCodes();
  }

  const options = codes
    .filter(
      (code) => code.entity === "Project" && code.field === "project_category"
    )
    .map((d) => ({
      label: d.label,
      value: d._id
    }));

  const value = Array.isArray(initialValue)
    ? options.filter((x) => initialValue.includes(x.value))
    : initialValue;

  return (
    <React.Fragment>
      {label ? (
        <label
          className={`control-label ${!label ? "hidden" : ""}`}
          htmlFor="project-category-type-select"
          style={{ textTransform: "uppercase" }}
        >
          {label}
        </label>
      ) : null}
      <Select
        name="project-category-type-select"
        id="project-category-type-select"
        className="react-select-container"
        classNamePrefix="react-select-container"
        fullwidth
        placeholder={placeholder}
        value={value}
        options={options}
        isClearable
        onChange={onChange}
        isMulti={isMulti}
        isDisabled={disabled}
      />
    </React.Fragment>
  );
};

ProjectCategorySelect.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  codes: PropTypes.array,
  actions: PropTypes.object,
  isMulti: PropTypes.bool,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool
};

ProjectCategorySelect.defaultProps = {
  placeholder: "Category",
  disabled: false
};

function mapStatesToProps(state) {
  return {
    codes: state.reducers.codes
  };
}
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        ...codeActions
      },
      dispatch
    )
  };
}

export default connect(
  mapStatesToProps,
  mapDispatchToProps
)(ProjectCategorySelect);
